import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "../utils/axiosConfig";
import { useWebSocket } from "../providers/WebSocketProvider";

export function useAuth() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { setToken } = useWebSocket();

  const handleLogin = async (e: React.FormEvent, onSuccess?: () => void) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const params = new URLSearchParams();
      params.append("grant_type", "password");
      params.append("username", email);
      params.append("password", password);
      params.append("scope", "");
      params.append("client_id", "string");
      params.append("client_secret", "string");

      const response = await axios.post("/token", params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      setToken(response.data.access_token);
      localStorage.setItem("userName", response.data.user.name);
      
      if (onSuccess) {
        onSuccess();
      } else {
        navigate("/tasks");
      }
    } catch (err) {
      setError("Login failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    error,
    isLoading,
    handleLogin
  };
} 